import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ITableCellModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import {
    IParagraphBox, ITextBox, ITextLineBox,
    IDocumentBox, DocumentElement,
} from '@tencent/alloy-editor';
import { IRect } from '@tencent/alloy-graphics/lib/types/path/base/interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { IPresentationModel } from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';

export enum AnalyzerResultType {
    SUCCESS = 0,
    ERROR = 1,
}

export interface AnalyzerResultDescriptionAndToSelectModel {
    description: string;
    selectable: boolean;
    selectSlide?: ISlideModel;
    selectElement?: IElementBaseModel;
    handleProblem?(index: number): void;
}

export interface IAnalyzerResult {
    analyzerName: string;
    description: string;
    resultType: AnalyzerResultType;
    resultInfo?: any;
    // 详细描述
    getDescriptionWithSelect(): Array<AnalyzerResultDescriptionAndToSelectModel> | undefined;
    // 处理方法
    handleProblem?(onHandled?: () => void, onCancel?: () => void): void;
    // 重置检测
    reset();
}

export interface ISlideNode {
    slide: ISlideModel;
    slideIndex: number;
}

export interface ILayoutTreeNode {
    slideNode: ISlideNode;
    // 从slide可以遍历到当前位置的描述
    path: Array<number>;
}

export interface IElementNode extends ILayoutTreeNode {
    element: IElementBaseModel;
}

export interface ITableCellNode extends IElementNode {
    cell: ITableCellModel;
}

export interface ITextBoxNode extends IElementNode {
    textRect: IRect;
    textDocumentElement: DocumentElement;
    textBoxPath: Array<number>;
}

export interface ITextBlockParentBoxNode extends ITextBoxNode {
    blockBox: IDocumentBox;
}

export interface ITextParagraphBoxNode extends ITextBoxNode {
    paraBox: IParagraphBox;
}

export interface ITextLineBoxNode extends ITextBoxNode {
    lineBox: ITextLineBox;
}

export interface ITextElementBoxNode extends ITextBoxNode {
    textBox: ITextBox;
}

export type IPresentationCallback
    = (presentation: IPresentationModel) => void;

export type ISlideCallback
    = (slideNode: ISlideNode) => void;

export type IElementCallback
    = (elementNode: IElementNode) => void;

export type ITableCellCallback
    = (tableCell: ITableCellNode) => void;

export type ITextBlockParentBoxCallback
    = (textBlockParentBoxNode: ITextBlockParentBoxNode) => void;

export type ITextParagraphBoxCallback
    = (textParagraphBoxNode: ITextParagraphBoxNode) => void;

export type ITextLineBoxCallback
    = (textLineBoxNode: ITextLineBoxNode) => void;

export type ITextElementBoxCallback
    = (textElementBoxNode: ITextElementBoxNode) => void;
